import React from 'react';

const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  href,
  cssClass,
  onClick,
  isBuyAndCollect,
  variant,
  isDisabled,
}) =>
  articleNumber ? (
    variant === 'secondary' ? (
      <button
        className="buy-btn bg-secondary group-[.buy-button-container--success]:bg-primary inline-grid size-16 place-items-center items-center rounded-full disabled:cursor-not-allowed"
        onClick={() => onClick(articleNumber, quantityFieldId, isBuyAndCollect)}
        aria-label={label}
        type="button"
        disabled={isDisabled}
        aria-busy={isDisabled}
      >
        <img
          src="/ui/images/icons/loading.svg"
          className="mt-[-6.25%] hidden size-8 animate-spin object-contain group-[.buy-button-container--loading]:block"
        />
        <img
          src="/ui/images/icons/check.svg"
          className="mt-[-6.25%] hidden size-8 object-contain group-[.buy-button-container--success]:block"
        />
        <img
          src="/ui/images/icons/cart.svg"
          className="mt-[-6.25%] size-8 object-contain group-[.buy-button-container--loading]:hidden group-[.buy-button-container--success]:hidden"
        />
      </button>
    ) : (
      <button
        className={`group-[.buy-button-container--success]:bg-primary block w-full group-[.buy-button-container--success]:border-none ${cssClass}`}
        onClick={() => onClick(articleNumber, quantityFieldId, isBuyAndCollect)}
        disabled={isDisabled}
        aria-busy={isDisabled}
      >
        <span className="group-[.buy-button-container--loading]:hidden group-[.buy-button-container--success]:hidden">
          {label}
        </span>
        <img
          src={
            isBuyAndCollect
              ? '/ui/images/icons/loading-dark.svg'
              : '/ui/images/icons/loading.svg'
          }
          className="mt-[-6.25%] hidden size-8 animate-spin object-contain group-[.buy-button-container--loading]:block"
        />
        <img
          src="/ui/images/icons/check.svg"
          className="mt-[-6.25%] hidden size-8 object-contain group-[.buy-button-container--success]:block"
        />
      </button>
    )
  ) : (
    <a className={cssClass} href={href}>
      {label}
    </a>
  );

export default BuyButton;
